export default {
  isMobile: state => state.screenWidth < 815,

  chatX: (state, getters) => (getters.isMobile ? 0 : state.screenWidth - 420),

  chatY: (state, getters) => {
    const offset = getters.isMobile ? 44 : 200
    return state.screenHeight - offset
  },

  chatWidth: (state, getters) => (getters.isMobile ? state.screenWidth : 395),

  chatMaxHeight: (state, getters) =>
    getters.isMobile ? state.screenHeight - 215 : getters.chatY - 250,

  sectionX: (state, getters) => (getters.isMobile ? 0 : state.mainSectionPosition.left),

  sectionY: (state, getters) => (getters.isMobile ? 44 : state.mainSectionPosition.top),

  sectionWidth: (state, getters) =>
    getters.isMobile ? state.screenWidth : state.mainSectionPosition.width,

  sectionHeight: (state, getters) =>
    getters.isMobile ? state.screenHeight - 88 : state.mainSectionPosition.height,

  temperatureX: state => (state.screenWidth < 500 ? 10 : state.screenWidth - 500),

  temperatureWidth: state => (state.screenWidth < 500 ? state.screenWidth - 20 : 383),

  darkMenuWidth: (state, getters) => (getters.isMobile ? state.screenWidth : 180),
}
